export default [
  {
    path: '/health',
    name: 'Health',
    component: () => import('../components/HealthStatus.vue'),
    meta: { 
      requiresAuth: false,
      title: 'Health Check'
    }
  }
]

